import * as kenAllComponent from './components/ken_all';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // 住所のアクション
  kenAllComponent.setAdrresEvent();
  // 希望するボランティア活動
  qualificationItemActions();
})

// 希望するボランティア活動
export function qualificationItemActions () {
  // 希望するボランティア活動
  let elements = document.querySelectorAll('input[name="volunteer_bank_inquiry_member[hope_volunteer_type]"]');

  if (!!elements.length) {
    // 専門的な支援活動
    var professional = document.getElementById('volunteer_bank_inquiry_member_hope_volunteer_type_hope_volunteer_type_professional');
    // 一般的・専門的両方の支援活動
    var both = document.getElementById('volunteer_bank_inquiry_member_hope_volunteer_type_hope_volunteer_type_normal_and_professional');
    // 資格・免許・技術・特技のラベル
    var label = professional.closest('.row').querySelector('label[for$="qualifications"]');
    // 資格・免許・技術・特技
    var checkboxes = professional.closest('.row').querySelectorAll('input[type="checkbox"]');

    for (var i = 0; i < elements.length; i++) {
      if (!!elements[i]) {
        elements[i].addEventListener('change', function(event) {
          if (event.target === professional || event.target === both) {
            if (!label.classList.contains('required')) {
              label.classList.add('required');
              for (var t = 0; t < checkboxes.length; t++) {
                checkboxes[t].disabled = false;
              }
            }
          } else {
            label.classList.remove('required');
            for (var t = 0; t < checkboxes.length; t++) {
                checkboxes[t].disabled = true;
            }
          }
        })
      }
    }
  }
}